// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Antd = require("antd");
var Curry = require("rescript/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var Router = require("next/router");
var Icons = require("@ant-design/icons");
var StripeJs = require("@stripe/stripe-js");
var Util$SmartcutsMacros = require("../../packages/bs-utils/src/Util.bs.js");
var ReactUtils$SmartcutsMacros = require("../../packages/bs-utils/src/ReactUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../packages/bs-utils/src/OptionUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../packages/bs-utils/src/PromiseUtils.bs.js");
var StripeUX__ManageSubscriptionButton$SmartcutsMacros = require("./StripeUX__ManageSubscriptionButton.bs.js");

var stripePromise = StripeJs.loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY);

function checkout(servicePlanId, onError) {
  fetch("/api/stripe/checkout", Fetch.RequestInit.make(/* Post */2, Caml_option.some(Js_dict.fromArray([[
                            "Content-type",
                            "application/json"
                          ]])), Caml_option.some(JSON.stringify(Json_encode.object_({
                              hd: [
                                "servicePlanId",
                                servicePlanId
                              ],
                              tl: /* [] */0
                            }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function (response) {
          var statusCode = response.status;
          if (statusCode >= 400) {
            if (statusCode >= 402) {
              return Util$SmartcutsMacros.logAndRaiseJsError("Unexpcted statusCode " + String(statusCode));
            } else {
              return PromiseUtils$SmartcutsMacros.resolveWith((function (message) {
                            console.error(message);
                            
                          }), response.text());
            }
          } else if (statusCode !== 200) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpcted statusCode " + String(statusCode));
          } else {
            return Promise.all([
                          stripePromise,
                          response.json()
                        ]).then(function (param) {
                        var sessionId = Json_decode.field("id", Json_decode.string, param[1]);
                        return param[0].redirectToCheckout({
                                    sessionId: sessionId
                                  });
                      });
          }
        }).catch(function (error) {
        Curry._1(onError, error);
        return Promise.resolve(undefined);
      });
  
}

function StripeUX__CheckoutButton(Props) {
  var servicePlanId = Props.servicePlanId;
  var price = Props.price;
  var user = Props.user;
  var currentSubscription = Props.currentSubscription;
  var router = Router.useRouter();
  var match = React.useState(function () {
        return {
                checkoutInProgress: undefined
              };
      });
  var setState = match[1];
  var checkoutInProgress = match[0].checkoutInProgress;
  var initCheckout = function (param) {
    Curry._1(setState, (function (param) {
            return {
                    checkoutInProgress: servicePlanId
                  };
          }));
    return checkout(servicePlanId, (function (error) {
                  console.error(error);
                  return Curry._1(setState, (function (param) {
                                return {
                                        checkoutInProgress: undefined
                                      };
                              }));
                }));
  };
  if (price === -1) {
    return React.createElement(Antd.Button, {
                href: "https://forms.gle/SnGTm1yH25baHM8z8",
                size: "large",
                target: "_blank",
                type: "primary",
                children: ReactUtils$SmartcutsMacros.s("Get in touch")
              });
  }
  if (user === undefined) {
    return React.createElement(Antd.Button, {
                href: "login?redirect=" + encodeURIComponent("/plans"),
                size: "large",
                type: "primary",
                children: ReactUtils$SmartcutsMacros.s("Log in and subscribe")
              });
  }
  if (currentSubscription !== undefined && currentSubscription.servicePlan._id === servicePlanId) {
    return React.createElement(Antd.Button, {
                disabled: true,
                icon: React.createElement(Icons.CheckCircleFilled, {}),
                size: "large",
                type: "primary",
                className: "currentPlan",
                children: ReactUtils$SmartcutsMacros.s("Current plan")
              });
  }
  if (checkoutInProgress !== undefined) {
    if (checkoutInProgress === servicePlanId) {
      return React.createElement(Antd.Button, {
                  disabled: true,
                  icon: React.createElement(Icons.LoadingOutlined, {}),
                  size: "large",
                  type: "primary",
                  children: ReactUtils$SmartcutsMacros.s("Loading")
                });
    } else {
      return React.createElement(Antd.Button, {
                  disabled: true,
                  size: "large",
                  type: "primary",
                  children: ReactUtils$SmartcutsMacros.s("Switch to this plan")
                });
    }
  }
  if (currentSubscription === undefined) {
    return React.createElement(Antd.Button, {
                size: "large",
                type: "primary",
                onClick: (function (_event) {
                    return initCheckout(undefined);
                  }),
                children: ReactUtils$SmartcutsMacros.s("Start with this plan")
              });
  }
  if (currentSubscription.servicePlan.subscriptionPrice === 0) {
    return React.createElement(Antd.Button, {
                size: "large",
                type: "primary",
                onClick: (function (_event) {
                    return initCheckout(undefined);
                  }),
                children: ReactUtils$SmartcutsMacros.s("Start with this plan")
              });
  }
  if (currentSubscription.servicePlan.subscriptionPrice <= 0) {
    return React.createElement(Antd.Button, {
                disabled: price === 0,
                size: "large",
                type: "primary",
                onClick: (function (_event) {
                    return initCheckout(undefined);
                  }),
                children: ReactUtils$SmartcutsMacros.s("Switch to this plan")
              });
  }
  var arg = currentSubscription.stripeCustomerId;
  return React.createElement(StripeUX__ManageSubscriptionButton$SmartcutsMacros.make, {
              type_: "button",
              stripeCustomerId: (function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                  })("Expect subscription.stripeCustomerId if subscription.price > 0"),
              router: router,
              children: ReactUtils$SmartcutsMacros.s("Switch to this plan")
            });
}

var make = StripeUX__CheckoutButton;

exports.stripePromise = stripePromise;
exports.checkout = checkout;
exports.make = make;
/* stripePromise Not a pure module */
